import { createSelector, createFeatureSelector } from '@ngrx/store'
import { BusinessOwnerState } from './business-owner.state'

// Selector to get all businesses from the state
// export const selectAllBusinesses = (state: BusinessState) => state.businesses

// // Selector to get loading state
// export const selectLoadingState = (state: BusinessState) => state.loading

// // Selector to get the error state
// export const selectErrorState = (state: BusinessState) => state.error

// Select the feature state
export const selectBusinessOwnerState = createFeatureSelector<BusinessOwnerState>('businessOwner')

// Selector to get all businesses from the state
export const selectAllBusinessOwners = createSelector(
  selectBusinessOwnerState,
  (state: BusinessOwnerState) => state.businessOwners
)
